/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Code_PlaceholderInputs */

const en_admin_permissions_code_placeholder = /** @type {(inputs: Admin_Permissions_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. posts.create`)
};

/**
* | output |
* | --- |
* | "e.g. posts.create" |
*
* @param {Admin_Permissions_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_code_placeholder = /** @type {((inputs?: Admin_Permissions_Code_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Code_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_code_placeholder(inputs)
});
export { admin_permissions_code_placeholder as "admin.permissions.code_placeholder" }